import { useNavigate } from 'react-router-dom';

import {
  activeDate,
  AdminLegendVariant,
  ProfessionalReplacementTypes,
} from '@pharmaplan/common';

import { setPrimaryRoute } from '../../actions/navbarActions';
import { Constants, PrimaryAdminNavigation } from '../../helpers/Constants';
import { getVisibleDatesMonth } from '../../helpers/Functions';
import { useAppDispatch } from '../useAppDispatch';
import { useAppSelector } from '../useAppSelector';

const { bookingReport, requestedReport, postedWorkshiftReport } = Constants.paths.admin;
const { booked, posted, requested } = AdminLegendVariant;

const pathMap = {
  [booked]: bookingReport,
  [posted]: postedWorkshiftReport,
  [requested]: requestedReport,
};

const useAdminLegendNavigation = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const currentDate = useAppSelector(activeDate);
  const { start, end } = getVisibleDatesMonth(currentDate);

  const handleNavigateToReport = (
    variant: `${AdminLegendVariant}`,
    replacementType: ProfessionalReplacementTypes | null,
  ) => {
    dispatch(setPrimaryRoute(PrimaryAdminNavigation.reports));
    navigate(pathMap[variant as keyof typeof pathMap], {
      state: {
        start,
        end,
        replacementType,
      },
    });
  };

  return { handleNavigateToReport };
};

export default useAdminLegendNavigation;
